import { Injectable } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../interviews.models";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class InterviewsService {
  private meetings: BehaviorSubject<CandidateMeetingModel[]> = new BehaviorSubject<CandidateMeetingModel[]>([]);
  private dashboardInfo: BehaviorSubject<InterviewDashboardResult | null> = new BehaviorSubject<InterviewDashboardResult | null>(null);
  public meetings$ = this.meetings.asObservable();
  public dashboardInfo$ = this.dashboardInfo.asObservable();

  public setMeetings(meetings: CandidateMeetingModel[]){
    this.meetings.next(meetings);
  }

  public setDashboardInfo(result: InterviewDashboardResult) {
    this.dashboardInfo.next(result);
  }

  public meetingInThePast(meeting: CandidateMeetingModel): boolean {
    if (!meeting.startDate || !meeting.endDate) return false;

    const startDate = new Date(meeting.startDate.user.isO8601);
    const endDate = new Date(meeting.endDate.user.isO8601);

    const now = new Date();

    return startDate < now || endDate < now; 
  }  

  public isJoinButtonEnabled(meeting: CandidateMeetingModel): boolean {
    const datesAreOnSameDay = (first: Date, second: Date) =>
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();

    let startDate = new Date(meeting.startDate!.utc.isO8601);
    let endDate = new Date(meeting.endDate!.utc.isO8601);
    let now = new Date();

    return datesAreOnSameDay(startDate, now) || datesAreOnSameDay(endDate, now);
  }  
}
